module.exports = __webpack_public_path__ + "img/2.076beba1.svg";